module.exports = {
    locale: $('meta[name="language"]').attr('content'),
    messages : {
        en: {
            compose : 'Compose',
            add_new_email : 'Add New Email',
            list_all_emails : 'List All Emails',
            smpt_details : 'SMTP Details',
            login_with : 'Login With',
            to_add_email : 'to add Email',
            other : 'SMTP',
            SMTP : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            email : 'Email',
            username : 'Username',
            smtp_username : 'SMTP username',
            smtp_host : 'SMTP Host',
            type : 'Type',
            added : 'Added',
            action : 'Action',
            delete : 'Delete',
            edit : 'Edit',
            from : 'From',
            to : 'To',
            subject : 'Subject',
            type_your_message : 'Type Your Message',
            attach_files : 'Attach Files',
            send : 'Send',
            email_address : 'Email address',
            password : 'Password',
            host : 'Outgoing server',
            port : 'Port',
            encryption : 'Encryption',
            create_account : 'Create Account',
            none: 'None',
            cc : 'CC',
            bcc : 'BCC',
            select_template : 'Select Template',
            save : 'Save',
            cancel : 'Cancel',
            email_sent : 'Email sent!',
            select_columns : 'Select Columns',
            close : "Close",
            select_field : 'Select Field',
            select_pdfs : 'Select PDFs',
            pdf_attachments : 'PDF Attachments',
            email_attachments : 'Email Attachments',
            pease_select_field : 'Please select field',
            please_select_column : 'Please select column',
            attach_pdfs : 'Attach PDFs',
            add_placeholder : 'Add Placeholder',
            choose_template : 'Choose Template',
            select_an_email_template : 'Select an email template',
            no_email : "You have not added any email address",
            add_email : 'Add Email Address'

        },
        sl: {
            compose : 'Novo',
            add_new_email : 'Dodaj novi račun',
            list_all_emails : 'Seznam vseh računov',
            smpt_details : 'SMTP podatki',
            login_with : 'Logiraj z',
            to_add_email : 'Dodaj Email',
            other : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            email : 'E-pošta',
            username : 'Uporabniško ime',
            smtp_username : 'SMTP Uporabniško ime',
            smtp_host : 'SMTP Odhodni strežnik',
            type : 'Vrsta',
            added : 'Dodano',
            action : 'Akcija',
            delete : 'Odstrani',
            edit : 'Uredi',
            from : 'Od',
            to : 'Do',
            subject : 'Zadeva',
            type_your_message : 'Vnesite sporočilo',
            attach_files : 'Dodaj priponke',
            send : 'Pošlji',
            email_address : 'E-pošta',
            password : 'Geslo',
            host : 'Strežnik za odhodno pošto',
            port : 'Port',
            encryption : 'Enkripcija',
            create_account : 'Kreiraj račun',
            none: 'Nič',
            select_template : 'Izberite predlogo',
            save : 'Shrani',
            cancel : 'Razveljavi',
            email_sent : 'Poslano!',
            select_columns : 'Izberite polje',

            close : "Zapri",
            select_field : 'Izberite polje',
            select_pdfs : 'Izberite PDF',
            pdf_attachments : 'PDF Priponke',
            email_attachments : 'E-poštne Priponke',
            pease_select_field : 'Izberite polje',
            please_select_column : 'Izberite stolpec',
            attach_pdfs : 'Pripni PDF',
            add_placeholder : 'Dodaj Placeholder',
            choose_template : 'Izberite predlogo',
            select_an_email_template : 'Izberite predlogo',

            no_email : " Potrebno je nastaviti e-poštni račun",
            add_email : 'Dodaj E-poštni račun'
        },
        hr: {
            compose : 'Compose',
            add_new_email : 'Add New Email',
            list_all_emails : 'List All Emails',
            smpt_details : 'SMTP Details',
            login_with : 'Login With',
            to_add_email : 'to add Email',
            other : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            username : 'Korisničko ime',
            smtp_username : "SMTP Korisničko ime",
            smtp_host : 'SMTP Host',
            type : 'Type',
            added : 'Added',
            action : 'Action',
            delete : 'Delete',
            edit : 'Uredi',
            from : 'From',
            to : 'To',
            subject : 'Subject',
            type_your_message : 'Type Your Message',
            attach_files : 'Attach Files',
            send : 'Send',
            email_address : 'Email address',
            password : 'Password',
            host : 'Outgoing server',
            port : 'Port',
            encryption : 'Encryption',
            create_account : 'Create Account',
            none: 'None',
            cc : 'CC',
            bcc : 'BCC',
            select_template : 'Select Template',
            save : 'Save',
            cancel : 'Cancel',
            email_sent : 'Email sent!',
            select_columns : 'Select Columns',
            close : "Close",
            select_field : 'Select Field',
            select_pdfs : 'Select PDFs',
            pdf_attachments : 'PDF Attachments',
            email_attachments : 'Email Attachments',
            pease_select_field : 'Please select field',
            please_select_column : 'Please select column',
            attach_pdfs : 'Priložite PDF',
            add_placeholder : 'Add Placeholder',
            choose_template : 'Choose Template',
            select_an_email_template : 'Select an email template',
            no_email : "You have not added any email address",
            add_email : 'Add Email Address'
        },
        fi: {
            compose : 'Compose',
            add_new_email : 'Add New Email',
            list_all_emails : 'List All Emails',
            smpt_details : 'SMTP Details',
            login_with : 'Login With',
            to_add_email : 'to add Email',
            other : 'SMTP',
            SMTP : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            email : 'Email',
            username : 'Username',
            smtp_username : "SMTP username",
            smtp_host : 'SMTP Host',
            type : 'Type',
            added : 'Added',
            action : 'Action',
            delete : 'Delete',
            edit : 'Redagować',
            from : 'From',
            to : 'To',
            subject : 'Subject',
            type_your_message : 'Type Your Message',
            attach_files : 'Attach Files',
            send : 'Send',
            email_address : 'Email address',
            password : 'Password',
            host : 'Outgoing server',
            port : 'Port',
            encryption : 'Encryption',
            create_account : 'Create Account',
            none: 'None',
            cc : 'CC',
            bcc : 'BCC',
            select_template : 'Select Template',
            save : 'Save',
            cancel : 'Cancel',
            email_sent : 'Email sent!',
            select_columns : 'Select Columns',
            close : "Close",
            select_field : 'Select Field',
            select_pdfs : 'Select PDFs',
            pdf_attachments : 'PDF Attachments',
            email_attachments : 'Email Attachments',
            pease_select_field : 'Please select field',
            please_select_column : 'Please select column',
            attach_pdfs : 'Attach PDFs',
            add_placeholder : 'Add Placeholder',
            choose_template : 'Choose Template',
            select_an_email_template : 'Select an email template',
            no_email : "You have not added any email address",
            add_email : 'Add Email Address'
        },
        pl: {
            compose : 'Compose',
            add_new_email : 'Add New Email',
            list_all_emails : 'List All Emails',
            smpt_details : 'SMTP Details',
            login_with : 'Login With',
            to_add_email : 'to add Email',
            other : 'SMTP',
            SMTP : 'SMTP',
            google_account : 'Gmail',
            microsoft_account : 'Outlook',
            email : 'Email',
            username : 'Wybierz SMTP',
            smtp_username : "Nazwa użytkownika SMTP",
            smtp_host : 'Host SMTP',
            type : 'Type',
            added : 'Added',
            action : 'Action',
            delete : 'Delete',
            edit : 'Edit',
            from : 'From',
            to : 'To',
            subject : 'Subject',
            type_your_message : 'Type Your Message',
            attach_files : 'Attach Files',
            send : 'Send',
            email_address : 'Email address',
            password : 'Password',
            host : 'Outgoing server',
            port : 'Port',
            encryption : 'Encryption',
            create_account : 'Create Account',
            none: 'None',
            cc : 'CC',
            bcc : 'BCC',
            select_template : 'Select Template',
            save : 'Save',
            cancel : 'Cancel',
            email_sent : 'Email sent!',
            select_columns : 'Select Columns',
            close : "Close",
            select_field : 'Select Field',
            select_pdfs : 'Select PDFs',
            pdf_attachments : 'PDF Attachments',
            email_attachments : 'Email Attachments',
            pease_select_field : 'Please select field',
            please_select_column : 'Please select column',
            attach_pdfs : 'Attach PDFs',
            add_placeholder : 'Add Placeholder',
            choose_template : 'Choose Template',
            select_an_email_template : 'Select an email template',
            no_email : "You have not added any email address",
            add_email : 'Add Email Address'
        }
    }
};